module.exports = __webpack_public_path__ + "img/ultraCodeBg@2x.6ed22782.png";